import React from 'react'

import {FieldGoalListEditableProps} from "../../../../render/goal-list/goal-list-editable"
import {FieldViewSize} from "../../../../const";

const debug = false
// const debug = "FieldDropdown_InlineEditable"

export default class FieldGoalType_GoalListEditable extends React.Component<FieldGoalListEditableProps, any> {

    private previousOption: any

    constructor(props:FieldGoalListEditableProps) {
        super(props);

        const value = this.props.model[this.props.field.fieldId]

        this.state = {
            initialPropsValue   : value, // required to check if currentOption update needed on props changed
            currentOption       : props.field._getOption(value),
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId]

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentOption       : props.field._getOption(value)
            }
        }

        return null // no changes
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()
        if (!this.state.showPopover) this.setState({showPopover: true})
    }
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any) => {
        this.previousOption = this.state.currentOption;
        if (!option || _.isNil(option.value)) option = null;

        this.setState({
            currentOption: option
        }, () => {
            // if (this.props.onChange) this.props.onChange(_.get(option, 'value', null), this.onCancelChange);
            if (this.props.onChange) this.props.onChange(_.get(option, 'value', null));
            this.hidePopover()
        });
    }

    onCancelChange = () => {
        this.setState({
            currentOption: this.previousOption
        });
    }

    render() {
        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        const isNotEmpty = this.state.currentOption && (field.hasOptionWithNullValue || !_.isNil(this.state.currentOption.value))
        debug && console.log(debug, 'render', isNotEmpty, this.props)

        // need check value because of none
        if (isNotEmpty) {
            return (
                <field.components.InlineValueNotEmpty className     = {classes}
                                                      field         = {this.props.field}
                                                      option        = {this.state.currentOption}
                                                      size          = {FieldViewSize.SMALL}
                                                      onClick       = {this.showPopover}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.InlineValueNotEmpty>
            );
        } else {
            return (
                <field.components.InlineValueEmpty className    = {classes}
                                                   field        = {this.props.field}
                                                   size         = {FieldViewSize.SMALL}
                                                   onClick      = {this.showPopover}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.InlineValueEmpty>
            );
        }
    }
}
